const grey300Color = '#E9EBEC';

export default grey300Color;
